import { put, call, takeEvery } from 'redux-saga/effects'

import { FETCH_CONFIGURATION } from '../actions/types'
import { fetchConfigurationSuccess, fetchConfigurationFailure } from '../actions/configurationActions'
import configurationService from '../services/configurationService'

function* handleFetchConfiguration(action) {
  try {
    const { accessToken } = action.payload

    // Fetch data from API
    const results = yield call(configurationService.fetchConfiguration, accessToken)

    yield put(fetchConfigurationSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching configuration')
    yield put(fetchConfigurationFailure(err))
  }
}

function* watchConfigurationSagas() {
  yield takeEvery(FETCH_CONFIGURATION, handleFetchConfiguration)
}

export default watchConfigurationSagas
